import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=01b899ad&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=01b899ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b899ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b899ad')) {
      api.createRecord('01b899ad', component.options)
    } else {
      api.reload('01b899ad', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=01b899ad&scoped=true&", function () {
      api.rerender('01b899ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4bHD2y2JfW43P/JS/comp/PopupBox.vue"
export default component.exports